import {Base64} from 'js-base64';

import {tryParseJson} from 'utils/transform';

export class UrlService {

    static getSearchParamValue = (key: string): string => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(key);
    };

    static getSearchParamJsonValue = (key: string): any => {
        const searchParamValue = UrlService.getSearchParamValue(key);
        const {success, value} = tryParseJson(searchParamValue);
        return success ? value : null;
    };

    static getSearchParamJsonValueBase64 = (key: string): any => {
        const searchParamValue = UrlService.getSearchParamValue(key);
        try {
            const decodedValue = Base64.decode(searchParamValue);
            const {success, value} = tryParseJson(decodedValue);
            return success ? value : null;
        } catch {
            return null;
        }
    };

    static getJsonUriValueBase64 = (text: string): any => {
        try {
            const decodedValue = Base64.decode(text);
            const {success, value} = tryParseJson(decodedValue);
            return success ? value : null;
        } catch {
            return null;
        }
    };

    static removeSearchParam = (key: string) => {
        const searchParams = new URLSearchParams(window.location.search);

        searchParams.delete(key);
        const searchParamsStr = searchParams.toString();
        const searchParamsQuery = searchParamsStr ? `?${searchParamsStr}` : '';
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + searchParamsQuery;
        window.history.replaceState({path: newurl}, '', newurl);
    };
}
